// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"119":"a8d17f17688fde72","525":"8f595bc1aac416dd","651":"bdd1b67d1cc825a1","741":"fdc4fe74f0af5414"}[chunkId] + ".js";
};